package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.AuthRepository

class UpdateSlugUseCase(
    private val authRepository: AuthRepository
) {
    suspend operator fun invoke(newSlug: String): Result<Unit> {
        return authRepository.updateSlug(newSlug)
    }

    suspend fun checkAvailable(slug: String): Boolean {
        return authRepository.checkSlugAvailable(slug)
    }
}
